// 工单状态
// 全部
export const TICKET_ALL_STATUS = 0;
// 处理中
export const TICKET_PROCESSING_STATUS = 1;
// 待评价
export const TICKET_NOT_EVALUATED_STATUS = 2;
// 已完结
export const TICKET_COMPLETE_STATUS = 3;

// 工单已评价
export const TICKET_HAS_BEEN_EVALUATED = 2;

export const TICKET_STATUS_INFO_MAP = {
  [TICKET_PROCESSING_STATUS]: {
    text: '受理中',
    color: 'processing',
  },
  [TICKET_NOT_EVALUATED_STATUS]: {
    text: '待评价',
    color: 'warning',
  },
  [TICKET_COMPLETE_STATUS]: {
    text: '已完结',
    color: 'success',
  },
};

export const TICKET_STATUS_OPTIONS = [
  {
    value: TICKET_ALL_STATUS,
    label: '全部',
  },
  {
    value: TICKET_PROCESSING_STATUS,
    label: '受理中',
  },
  {
    value: TICKET_NOT_EVALUATED_STATUS,
    label: '待评价',
  },
  {
    value: TICKET_COMPLETE_STATUS,
    label: '已完结',
  },
];
// 工单自定义字段类型
// 文本
export const CUSTOM_FIELD_TEXT_TYPE = 0;
// 文本类型细分(description) - 单行文本
export const CUSTOM_FIELD_SINGLE_TEXT_TYPE = '0-0';
// 文本类型细分(description) - 数字文本
export const CUSTOM_FIELD_NUMBER_TEXT_TYPE = '0-1';
// 文本类型细分(description) - 多行文本
export const CUSTOM_FIELD_TEXTAREA_TYPE = '0-2';
// 下拉单选
export const CUSTOM_FIELD_SINGLE_SELECT_TYPE = 1;
// 多选
export const CUSTOM_FIELD_MULTI_SELECT_TYPE = 2;
// 时间控件
export const CUSTOM_FIELD_DATE_TYPE = 3;
// 级联
export const CUSTOM_FIELD_CASCADE_TYPE = 6;
// 附件
export const CUSTOM_FIELD_ATTACHMENT_TYPE = 7;

export const FORM_LAYOUT = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

export const FORM_ACTION_LAYOUT = {
  wrapperCol: { offset: 8, span: 8 },
};

// 连接符
export const FIELD_NAME_SEPARATOR = '-';
// 必填表单默认值
export const FIELD_DEFAULT_VALUE = '--';

export const NEED_ONBLUR_TRIGGER_FIELDS = [
  CUSTOM_FIELD_SINGLE_TEXT_TYPE,
  CUSTOM_FIELD_NUMBER_TEXT_TYPE,
  CUSTOM_FIELD_TEXTAREA_TYPE,
];

export const CUSTOM_FIELD_SELECT_TYPES = [
  CUSTOM_FIELD_SINGLE_SELECT_TYPE,
  CUSTOM_FIELD_MULTI_SELECT_TYPE,
];

// export const PAGE_SIZE = 20;
export const PAGE_SIZE = 10;
export const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const CREATE_TICKET_STEPS = [
  { key: 1, title: '选择问题类型' },
  { key: 2, title: '填写故障详情' },
  { key: 3, title: '等待提交结果' },
];

export const MAX_ATTACHMENT_NUM = 5;
export const MAX_ATTACHMENT_SIZE = 500;

export const DEVICE_MATCH_KEY = ['sn', 'remark', 'groupName', 'deviceType'];

export const TARGET_STAFF_ID = '6250098';

export const PAGE_MODULE = 'service';
export const TICKET_LIST_PAGE_NAME = 'ticket_list';
export const TICKET_DETAIL_PAGE_NAME = 'ticket_detail';
export const CREATE_TICKET_PAGE_NAME = 'create_ticket';

// 需要特殊处理的SN字段名
export const SN_FIELD_NAME = '【通用】设备SN';
export const COMMON_FIELD_NAME_PREFIX = '【通用】';
// 模板通用对内标识
export const TEMPLATE_NAME_SUBFIX = '工单通用模板';

export const STORAGE_CURRENT_STEP_KEY = 'createTicketStep';

export const STORAGE_SHOW_BACK_TIP_MODAL = 'createTicketBackToFirstStep';

// 创建结果状态码
// 成功
export const CREATE_SUCCESS_CODE = 0;
// 网络错误
export const CREATE_NETWORK_ERROR_CODE = 1;
// 模版错误
export const CREATE_TEMPLATE_ERROR_CODE = 2;
// 空
export const EMPTY_ERROR_CODE = -1;
// 空列表
export const TICKET_LIST_EMPTY_CODE = -2;

export const TICKET_RES_MAP = {
  [CREATE_SUCCESS_CODE]: {
    title: '提交成功',
    subTitle: '我们将会尽快处理您的工单，请耐心等待结果反馈！',
  },
  [CREATE_TEMPLATE_ERROR_CODE]: {
    title: '提交失败',
    subTitle: '很抱歉，工单提交失败，请您刷新后重试',
  },
  [CREATE_NETWORK_ERROR_CODE]: {
    title: '提交失败',
    subTitle: '很抱歉，您的网络较差导致提交失败，请稍后重试',
  },
  [EMPTY_ERROR_CODE]: {
    title: '暂无数据',
    subTitle: '暂无数据，请稍后刷新重试',
  },
  [TICKET_LIST_EMPTY_CODE]: {
    title: '',
    subTitle: '您近3个月没有此状态的工单哦',
  },
};

// 工单日志类型
// 创建
export const TICKET_CREATE_LOG_TYPE = 1;
// 更新
export const TICKET_UPDATE_LOG_TYPE = 20;
// 完结
export const TICKET_FINISHED_LOG_TYPE = 25;

export const TICKET_LOG_TITLE_MAP = {
  [TICKET_CREATE_LOG_TYPE]: '工单已创建',
  [TICKET_UPDATE_LOG_TYPE]: '工单受理中',
  [TICKET_FINISHED_LOG_TYPE]: '工单已结束',
};

export const DEFAULT_SEARCH_PARAMS = {
  page: 1,
  pageSize: PAGE_SIZE,
  status: TICKET_ALL_STATUS,
  fuzzyQuery: '',
};

export const DEFAULT_RATE_ITEM = {
  commentRequired: false,
  name: '',
  tagList: [],
  tagRequired: false,
  value: -1,
};

// 已解决
export const TICKET_RESLOVED = 1;
// 未解决
export const TICKET_NOT_RESOLVED = 2;
export const TICKET_SLOVED_OPTIONS = [
  {
    value: TICKET_RESLOVED,
    label: '已解决',
  },
  {
    value: TICKET_NOT_RESOLVED,
    label: '未解决',
  },
];

export const DEFAULT_RULE = {
  model: 5,
  resolvedEnabled: 0,
  resolvedRequired: 0,
  settings: [
    {
      commentRequired: false,
      name: '非常不满意',
      tagList: ['服务质量极差', '处理结果不匹配', '超时催单'],
      tagRequired: true,
      value: 1,
    },
    {
      commentRequired: false,
      name: '不满意',
      tagList: ['服务质量较差', '优化结果不详细'],
      tagRequired: true,
      value: 25,
    },
    {
      commentRequired: false,
      name: '一般',
      tagList: ['解决能力有限需改进', '产品原因'],
      tagRequired: true,
      value: 50,
    },
    {
      commentRequired: false,
      name: '满意',
      tagList: ['比较满意', '催单处理完成'],
      tagRequired: false,
      value: 75,
    },
    {
      commentRequired: false,
      name: '非常满意',
      tagList: ['工单高效', '处理准确', '技术一级棒'],
      tagRequired: false,
      value: 100,
    },
  ],
  evaluationWay: 4,
};
